import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ExternalLink } from "lucide-react";
import { SeasonProvider, useSeasonContext } from "@/contexts/SeasonContext";

const CastlePromoContent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { isSummer } = useSeasonContext();

  useEffect(() => {
    // Le popup s'affiche 4 secondes après chaque actualisation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  // Définition de la couleur du bouton selon la saison
  const btnSeasonClass = isSummer ? "bg-summer-accent hover:bg-summer-accent-dark" : "bg-ochre hover:bg-ochre-dark";

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="max-w-[280px] sm:max-w-[280px]"
        >
          <div className="relative bg-cream/95 backdrop-blur-sm border border-gold/20 rounded-lg shadow-xl p-4">
            {/* Bouton fermer réduit */}
            <button
              onClick={handleClose}
              className="absolute top-2 right-2 text-charcoal/50 hover:text-charcoal transition-colors duration-200"
              aria-label="Fermer"
            >
              <X className="w-3.5 h-3.5" />
            </button>

            {/* Contenu réduit */}
            <div className="pr-4">
              <h3 className="font-playfair text-base text-charcoal mb-1 leading-tight">
                Visitez le Château Fort de Roquetaillade
              </h3>
              <p className="text-charcoal/70 text-xs mb-3 leading-snug">
                Découvrez ce site historique au cœur du vignoble bordelais.
              </p>

              {/* Bouton avec style dynamique selon la saison */}
              <a
                href="https://www.roquetaillade.eu"
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex items-center gap-1.5 px-4 py-2 text-xs font-medium text-white rounded-lg transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-y-0.5 ${btnSeasonClass}`}
              >
                Découvrir
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>

            {/* Accent décoratif discret (adapté aussi à la saison) */}
            <div
              className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent ${isSummer ? "via-summer-accent/40" : "via-gold/40"} to-transparent rounded-b-lg`}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const CastlePromoPopup = () => {
  return (
    <SeasonProvider>
      <CastlePromoContent />
    </SeasonProvider>
  );
};

export default CastlePromoPopup;
